import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { CallBrief } from "@/components/rcc/li/CallBrief";
import { api } from "@/lib/api";

const sameDay = (d) => { const a = new Date(d), b = new Date(); return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); };
const time = (d) => new Date(d).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

export const TodayCalls = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { Promise.all(["hiring_manager", "mpc_pitch"].map((a) => api.get(`/admin/rcc/li/prospects?audience=${a}&status=call_booked`).then((r) => r.data?.items || []).catch(() => []))).then(([a, b]) => setItems([...a, ...b].filter((p) => p.call_at && sameDay(p.call_at)).sort((x, y) => new Date(x.call_at) - new Date(y.call_at)))); }, []);
  if (!items) return null;
  return (
    <div className="rounded-2xl border border-[#D4AF37]/40 bg-[#0f0f12] p-4" data-testid="today-calls">
      <div className="mb-2 flex flex-wrap items-center gap-2">
        <CalendarClock className="h-4 w-4 text-[#D4AF37]" />
        <h3 className="font-display text-lg text-zinc-50">Today's booked calls</h3>
        <span className="rounded-full bg-[#D4AF37]/15 px-2 py-0.5 text-[10px] font-semibold text-[#F3C649]" data-testid="today-calls-count">{items.length}</span>
        <Link to="/admin/rcc/linkedin" className="ml-auto text-xs text-[#d7b6ff] hover:underline" data-testid="today-calls-all">All prospects</Link>
      </div>
      {!items.length ? <p className="text-xs text-zinc-500" data-testid="today-calls-empty">No calls booked for today.</p> : <div className="space-y-3">{items.map((p) => (
        <div key={p.id} className="space-y-2 border-t border-[#1f1f23] pt-3" data-testid={`today-call-${p.id}`}>
          <p className="text-sm text-zinc-100"><span className="mr-2 font-mono text-xs text-[#F3C649]">{time(p.call_at)}</span><span className="font-semibold">{p.first_name} {p.last_name}</span><span className="text-zinc-500">{[p.title, p.company].filter(Boolean).length ? ` · ${[p.title, p.company].filter(Boolean).join(" · ")}` : ""}</span></p>
          <CallBrief p={p} />
        </div>
      ))}</div>}
    </div>
  );
};
